import { Node } from './../../../my-features/node/node.model';
import { Component, OnInit, OnDestroy, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Location } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { isODM } from '../../../../environments/environment';
import { Confirm_button } from '../../../../environments/environment';
import { TreeNode, MessageService, SelectItem } from 'primeng/api';
import { RegionService } from '../../../services/region.service';
import { CryptoService} from '../../../services/crypto.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as fromFeature from '../../../my-features';
import { Account } from '../../../my-features/account/account.model';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MspAuthorityForUpdate, MspDeleteData } from '../../../my-features/region/region.model';
import { updateInfoType } from '../../../shareModel';
import { UpdateInfoModel } from '../../../my-features/updateInfo/update-info.model';
import { MspRegion, Region } from '../../../my-features/region/region.model';
import { DialogComponent } from '../../../../app/dialog/dialog.component';
import * as fromMyfeatures from '../../../my-features';

@Component({
  standalone: false,
  selector: 'app-authority-mgt',
  templateUrl: './authority-mgt.component.html',
  styleUrls: ['./authority-mgt.component.css']
})
export class AuthorityMgtComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.UI();
    this.InitialHeight();
  }
  private componentDestroyed = new Subject();
  authorityMgt_list: TreeNode[] = [];
  Confirm_button = Confirm_button;
  authorityMgt_cols: any[] = [
    { field: 'label', header: 'Member', width: '250', class: 'col-nowrap', disabled: false },
    { field: 'company', header: 'Company', width: '300', class: 'col-nowrap company', disabled: false },
    { field: 'auth', header: 'Authority', width: '300', class: 'col-nowrap', disabled: false },
    { field: 'mailReport', header: 'Email Report', width: '200', class: 'col-nowrap', disabled: false },
    // { field: 'all', header: 'all', width: '300', class: 'col-nowrap ellipsis', disabled: false },
    // { field: 'view', header: 'Viewer', width: '200', class: 'col-nowrap ellipsis', disabled: false },
    // { field: 'add', header: 'Add', width: '100', class: 'col-nowrap ellipsis', disabled: false },
    // { field: 'edit', header: 'Device Manager', width: '200', class: 'col-nowrap ellipsis', disabled: false },
    // { field: 'delete', header: '', width: '100', class: 'col-nowrap ellipsis', disabled: false },
    // { field: 'group', header: 'Group', width: '100', class: 'col-nowrap ellipsis', disabled: false },
    // { field: 'firmware', header: 'Firmware', width: '100', class: 'col-nowrap ellipsis', disabled: false },
  ];
  UpdateInfoParam = {} as UpdateInfoModel;
  // mspCompanyOptions 假資料範例
  // mspCompanyOptions = [
  //   { label: 'All Company', value: 'All' },
  //   { label: 'SHI Company', value: 'SHI Company' },
  //   { label: 'SHI One', value: 'SHI One' },
  //   { label: 'ABC Company', value: 'ABC Company' },
  //   { label: 'UPShockTest', value: 'UPShockTest' },
  //   { label: 'Aspen Dental', value: 'Aspen Dental' },
  // ];
  mspCompanyOptions = [];
  addMspCompanyOptions = [];

  account: Account[];
  accountDic = {};
  regionDic = {};
  authorityDictByAcode = {};
  topMspId: number;
  defaultMspId: number;
  selectedCheckboxCount = 0;
  isSelectAll = false;
  rowData: TreeNode[] = [];
  dialogInput: {
    selectedCompany: any[];
  };
  displayAuthority = false;
  displayConfirmDialog = false;
  permissionsValueArray = [];
  ReadRegionParam: {
    MspMainRegionId: number
    otp: string;
  };
  GetMspAuthorityParam: {
    RegionIds: number[]
    otp: string;
  };
  selectedAddAcode: number;
  selectedDeleteAuthority: {
    acode: number;
    RegionId: number;
  };
  searchString: string;
  selectedComapny: any = null;

  region: MspRegion[];
  treeRegion: any[] ;
  selectedRegion: any = null;
  selectedRegionName:string = '';
  selectedRegionId: number;
  selectedParentRegionId: number;
  selectedHashObj:string = '';
  selectedAdmins = [];
  selectedCreateId: number;
  selectedMainAdmin: number;
  adminsOptions: SelectItem[];

  globalSelectedRegionName: string;
  globalSelectedRegionId: number;
  globalSelectedParentRegionId: number;
  globalIsClickMemberbutton = false;
  mainMspAdmin: string;
  saveButtonDisable:boolean = true;
  IsSuperAdmin = false;
  IsAdmin = false;
  isMsp = false;
  acode : number;
  regionLoaded = false;
  mspRegionLoaded = false;
  mspAuthorityLoaded = false;
  getMspAuthorityFlag = false;
  pageLoading: boolean = true;
  treeRegionGrid_Region = [{}, {}, {}, {}, {}];
  region_list = [];
  deleteflag = false;
  delete_arrary: MspDeleteData[] = [];
  currentUser : any;

  constructor(private ngxService: NgxUiLoaderService, private store: Store<fromStore.State>, private location: Location,
    private apiService: RegionService, private cryptoService: CryptoService, private route: ActivatedRoute, private router: Router,
    private messageService: MessageService) {

    const hashStr = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('hashStr'));
    if (hashStr) {
      const regionIds = hashStr.split(',');
      if (regionIds !== undefined) {
        this.ReadRegionParam = {
          MspMainRegionId: parseInt(regionIds[0]),
          otp: ''
        };
        this.getMspRegion();
        this.regionLoaded = true;
        if (regionIds[1] !== undefined) {
          this.selectedRegionId = parseInt(regionIds[1])
        }
      }
    } else {
      // For Pro AccountManageMent Get MspMainRegionId
      this.store.select(fromStore.getCurrentUser).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
        if (res !== undefined) {
          this.isMsp = res.isMsp;
          if (!res.isMsp) {
            this.router.navigate(['/index']);
          }
          this.IsSuperAdmin = res.authority && res.authority === 2 ? true : false;
          this.IsAdmin = res.authority && res.authority > 0 ? true : false;
          this.acode = res.acode;
          this.currentUser = res;
          // if (!this.IsSuperAdmin) { // 暫時只有SystemAdmin權限看得到
          //   this.authorityMgt_cols = this.authorityMgt_cols.filter(s=> s.field !== "mailReport");
          // }
        }
      });
  
      this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
        if (!this.regionLoaded && res !== undefined && res.length > 0) {
          if (
            this.isMsp && this.IsSuperAdmin === false) {
            const mspMainRegionItem = res.find(r => r.Admins !== undefined && r.Admins.filter(i => i === this.acode) !== undefined);
            const mspMainRegionId = mspMainRegionItem !== undefined ? mspMainRegionItem.MspMainRegionId : undefined;
            this.ReadRegionParam = {
              MspMainRegionId: mspMainRegionId,
              otp: ''
            };
            // if (this.currentUser.RegionId !== mspMainRegionId) { // 不是母公司Admin就不顯示mailReport欄位
            //   this.authorityMgt_cols = this.authorityMgt_cols.filter(s=> s.field !== "mailReport");
            // }
            this.getMspRegion();
            this.regionLoaded = true;
          }
        }
      });
    }
    

    this.store.select(fromStore.getMspRegion).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined) {
        this.region = res;
        this.getTreeRegion();
      } else {
        if (this.ReadRegionParam !== undefined && !this.regionLoaded) {
          this.getMspRegion();
        }
      }
    });
    
    this.store.select(fromStore.getMspRegionState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        this.mspRegionLoaded = true;
      }
    });
    
    this.store.select(fromStore.getAccountInfo).pipe(takeUntil(this.componentDestroyed)).subscribe(resAccount => {
      if (resAccount !== undefined) {
        // Get Account Dictionary
        this.account = Object.values(resAccount);
        this.accountDic = {};
        this.account.map((i) => {
          this.accountDic[i.Acode] = i.Account;
          this.accountDic[i.Account] = i;
        });
      }
    });

    // open member button
    this.store.select(fromStore.getRegionMember).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.isLoaded && !res.isLoading) {
        if (res.entities) {
          if (res.entities.msg) {
            if (res.entities.msg.body) {
              if (Array.isArray(res.entities.msg.body)) {
                if (this.childDialog !== undefined && this.childDialog.companyMemberList !== undefined) {
                  this.childDialog.companyMemberList = [];
                  this.mainMspAdmin = '';
                  let admin = [];
                  if (this.selectedAdmins !== undefined) {
                    admin = this.selectedAdmins.filter(i => i !== this.selectedCreateId);
                  }
                  const mainMspAdminItem = this.account.find(s => s.Acode === this.selectedMainAdmin);
                  res.entities.msg.body.forEach((item) => {
                    if (this.accountDic[item] != undefined) {
                      this.childDialog.companyMemberList.push({ 'account': item, value: item, 'acode': this.accountDic[item].Acode, 'admins': admin, 'company': this.selectedRegionName });
                    }
                  });
                  const members = [];
                  this.childDialog.companyMemberList.forEach(c => {
                    members.push(c.account);
                  });

                  if (mainMspAdminItem !== null && mainMspAdminItem !== undefined) {
                    const memberList = this.childDialog.companyMemberList;
                    this.mainMspAdmin = mainMspAdminItem.Account;
                    this.childDialog.companyMemberList = [];
                    memberList.map(s => {
                      if (mainMspAdminItem.Account !== s.account && this.accountDic[s.account] != undefined) {
                        this.childDialog.companyMemberList.push({ 'account': s.account, value: s.account, 'acode': this.accountDic[s.account].Acode, 'admins': admin, 'company': this.selectedRegionName });
                      }
                    });
                  } else {
                    this.childDialog.companyMemberList = [];
                  }
                }
              }
            }
          }
        }
      }
      if (this.globalIsClickMemberbutton) {
        // tslint:disable-next-line: max-line-length
        this.childDialog.addCompanyMemberDialog(this.globalSelectedRegionName, this.globalSelectedRegionId, this.globalSelectedParentRegionId);
        this.globalIsClickMemberbutton = false;
      }
    });

    combineLatest(this.store.select(fromStore.getMspRegion),
      this.store.select(fromStore.getCurrentUser))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([resMspRegion, getCurrentUserRes]) => {

        if (resMspRegion !== undefined) {
          // Get Region List
          this.region_list = [];
          this.regionDic = {};
          this.mspCompanyOptions = [];
          this.mspCompanyOptions.push({ label: 'All', value: -1 });
          resMspRegion.map(i => {
            this.regionDic[i.Id] = i;
            this.region_list.push(i);
            this.mspCompanyOptions.push({ label: i.RegionName, value: i.Id });
          });
        }

        if (getCurrentUserRes !== undefined && getCurrentUserRes !== null) {
          this.IsSuperAdmin = getCurrentUserRes.authority === 2;
        }
      });

    combineLatest(this.store.select(fromStore.getMspAuthority),
      this.store.select(fromStore.getMspRegionHierarchy))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([getMspAuthority, regionHierarchy]) => {
        
        if ( regionHierarchy !== undefined) {
          //取得下層的regionId
          const ids = [];
          if (regionHierarchy.length > 0) {
            
            const targetId = this.selectedRegionId;
            const collectIds = (item: any) => {
              ids.push(item.Id);  
              if (item.children) { 
                item.children.forEach(collectIds);
              }
            };

            const findNodeById = (nodes: any[], targetId: number): any | null => {
              for (const node of nodes) {
                if (node.Id === targetId) {
                  collectIds(node); 
                  return true; 
                }
                if (node.children) {
                  if (findNodeById(node.children, targetId)) {
                    return true; 
                  }
                }
              }
              return false; 
            };
            regionHierarchy.forEach((rootNode) => {
              findNodeById([rootNode], targetId);
            });
          }
          if (getMspAuthority && getMspAuthority !== undefined) {
            if (Object.keys(getMspAuthority).length !== 0) {
              this.getMspAuthorityFlag = true;
            // Get Msp Authority
            this.authorityDictByAcode = {};
            const region_member_list = [];
            if (this.region_list ) {
              this.region_list.forEach((r) =>{
                if (r.ParentRegionId !== -1) {
                  region_member_list.push(r)
                }
              })
            }
            getMspAuthority.map((i) => {
              const regionId = i.RegionId !== undefined ? i.RegionId : i.AuthRegionId
              if (this.authorityDictByAcode[i.acode] != null && this.authorityDictByAcode[i.acode] != undefined) {
                if (regionId != null && regionId != undefined) {
                  const childObj = {
                    data: {
                      company: this.regionDic[regionId] !== undefined ? this.regionDic[regionId].RegionName : i.RegionName !== undefined ? i.RegionName : '',
                      // company: i.RegionName,
                      id: regionId,
                      rowType: 'children',
                      view: i.ViewDevice.toString(),
                      edit: i.EditDevice.toString(),
                      ValueType: 'checkbox',
                      parentAcode: i.acode,
                      isEdited: false,  // 判斷是否為 DB 讀進來後, 或各種情況下被編輯過 (用以判斷 update 時是否把資料放進 API)
                      isNew: false,  // 判斷是否為 User 新增的資料 (用以判斷 delete 時是否真的需要呼叫 API)
                      IsRestrictEditing: this.regionDic[regionId] === undefined ? true : false, // 較高層級的 Company, 需限制編輯, 判斷依據是看這一條的 RegionId 是否在可選擇的 mspCompanyOptions 清單內 (用 dictionary 判斷較快)
                      isdisabled: false,
                      weekly: (i.WeeklyReport === 0) ? false : true,
                      monthly:(i.MonthlyReport === 0) ? false : true,
                      // weekly: false,
                      // monthly: false,
                      mailDisabled: false
                    }
                  };
                  this.authorityDictByAcode[i.acode].data.view = (i.ViewDevice === 0) ? '0' : this.authorityDictByAcode[i.acode].data.view;
                  this.authorityDictByAcode[i.acode].data.edit = (i.EditDevice === 0) ? '0' : this.authorityDictByAcode[i.acode].data.edit;
                  // this.authorityDictByAcode[i.acode].data.weekly = (i.WeeklyReport === 0) ? false : true; // ReportType: 0 = all, 1 = daily, 2 = Weekly, 3 = Monthly
                  // this.authorityDictByAcode[i.acode].data.monthly = (i.MonthlyReport === 0) ? false : true;
  
                  if ((this.regionDic[regionId] !== undefined && this.regionDic[regionId].Admins !== undefined)) {
                    this.authorityDictByAcode[i.acode].data.view = (this.regionDic[regionId].Admins.includes(i.acode)) ? '1' : this.authorityDictByAcode[i.acode].data.view;
                    this.authorityDictByAcode[i.acode].data.edit = (this.regionDic[regionId].Admins.includes(i.acode)) ? '1' : this.authorityDictByAcode[i.acode].data.edit;
                    childObj.data.view = (this.regionDic[regionId].Admins.includes(i.acode)) ? '1' : childObj.data.view;
                    childObj.data.edit = (this.regionDic[regionId].Admins.includes(i.acode)) ? '1' : childObj.data.edit;
                    if (this.regionDic[regionId].Admins.includes(i.acode)) {
                      this.authorityDictByAcode[i.acode].data.isAccountMgt = true;
                      childObj.data.isdisabled = true;
                    }
                  }
                  this.authorityDictByAcode[i.acode].children.push(childObj);
                }
              } else {
                const memberObj = {
                  data: {
                    acode: i.acode,
                    label: this.accountDic[i.acode] ? this.accountDic[i.acode] : '',
                    rowType: 'Group',
                    view: '1',
                    edit: '1',
                    ValueType: 'checkbox',
                    isAccountMgt: this.selectedAdmins !== undefined && this.selectedAdmins.find(a=>a == i.acode) ? true : false,
                    weekly: true,
                    monthly: true,
                    mailDisabled: false
                  },
                  expanded: true,
                  children: []
                };
    
                if (regionId != null && regionId != undefined) {
                  const childObj = {
                    data: {
                      company: this.regionDic[regionId] !== undefined ? this.regionDic[regionId].RegionName : i.RegionName !== undefined ? i.RegionName : '',
                      // company: i.RegionName,
                      id: regionId,
                      rowType: 'children',
                      view: i.ViewDevice.toString(),
                      edit: i.EditDevice.toString(),
                      ValueType: 'checkbox',
                      parentAcode: i.acode,
                      isEdited: false,  // 判斷是否為 DB 讀進來後, 或各種情況下被編輯過 (用以判斷 update 時是否把資料放進 API)
                      isNew: false,  // 判斷是否為 User 新增的資料 (用以判斷 delete 時是否真的需要呼叫 API)
                      IsRestrictEditing: this.regionDic[regionId] === undefined ? true : false, // 較高層級的 Company, 需限制編輯, 判斷依據是看這一條的 RegionId 是否在可選擇的 mspCompanyOptions 清單內 (用 dictionary 判斷較快)
                      isdisabled: false,
                      weekly: (i.WeeklyReport === 0) ? false : true,
                      monthly:(i.MonthlyReport === 0) ? false : true,
                      // weekly: true,
                      // monthly: true,
                      mailDisabled: false
                    }
                  };
                  if (i.ViewDevice === 0 && i.EditDevice === 0) {
                    memberObj.data.view = '-1';
                    memberObj.data.edit = '-1';
                    childObj.data.view = '-1';
                    childObj.data.edit = '-1';
                    memberObj.data.weekly = false;
                    memberObj.data.monthly = false;
                    childObj.data.weekly = false;
                    childObj.data.monthly = false;
                    memberObj.data.mailDisabled = true;
                    childObj.data.mailDisabled = true;
                  } else {
                    memberObj.data.view = (i.ViewDevice === 0) ? '0' : memberObj.data.view;
                    memberObj.data.edit = (i.EditDevice === 0) ? '0' : memberObj.data.edit;
                  }
  
                  if ((this.regionDic[regionId] !== undefined && this.regionDic[regionId].Admins !== undefined)) {
                    memberObj.data.view = (this.regionDic[regionId].Admins.includes(i.acode)) ? '1' : memberObj.data.view;
                    memberObj.data.edit = (this.regionDic[regionId].Admins.includes(i.acode)) ? '1' : memberObj.data.edit;
                    childObj.data.view = (this.regionDic[regionId].Admins.includes(i.acode)) ? '1' : childObj.data.view;
                    childObj.data.edit = (this.regionDic[regionId].Admins.includes(i.acode)) ? '1' : childObj.data.edit;
                    if (this.regionDic[regionId].Admins.includes(i.acode)) {
                      memberObj.data.isAccountMgt = true;
                      childObj.data.isdisabled = true;
                    }
                  }
  
                  memberObj.children.push(childObj);
                }
    
                this.authorityDictByAcode[i.acode] = memberObj;
              }
            });

            for (const acode in this.authorityDictByAcode) {
              const existingRegionIds = this.authorityDictByAcode[acode].children.map(c => c.data.id);
              const missingRegions = region_member_list.filter(region => !existingRegionIds.includes(region.Id) && ids.includes(region.Id));
              const isAccountMgt = this.authorityDictByAcode[acode].data.isAccountMgt
              if (isAccountMgt) {
                this.authorityDictByAcode[acode].children.forEach(s => {
                  s.data.isdisabled = true;
                  s.data.edit = '1';
                  s.data.view = '1';
                  // s.data.weekly = true;
                  // s.data.monthly = true;
                  s.data.mailDisabled = false;
                })
              }
              for (const region of missingRegions) {
                const childObj = {
                  data: {
                    company: region.RegionName,
                    id: region.Id,
                    rowType: 'children',
                    view: isAccountMgt !== undefined && isAccountMgt ? '1' : '-1',
                    edit: isAccountMgt !== undefined && isAccountMgt ? '1' : '-1',
                    ValueType: 'checkbox',
                    parentAcode: acode,
                    isEdited: false,
                    isNew: false,
                    IsRestrictEditing: this.regionDic[region.Id] === undefined,
                    isdisabled: isAccountMgt !== undefined ? isAccountMgt : false,
                    weekly: isAccountMgt !== undefined && isAccountMgt ? true : false,
                    monthly: isAccountMgt !== undefined && isAccountMgt ? true : false,
                    mailDisabled: false
                  }
                };
                if (childObj.data.edit == '-1') { // None
                  childObj.data.weekly = false;
                  childObj.data.monthly = false;
                  childObj.data.mailDisabled = true;
                }
            
                this.authorityDictByAcode[acode].children.push(childObj);
              }
              this.authorityDictByAcode[acode].children = [...this.authorityDictByAcode[acode].children].sort(function (a: any, b: any) {
                return a.data.id - b.data.id;
              });
            }
            this.applySearch();
            } else {
              this.authorityDictByAcode = [];
              this.applySearch();
            }
            
          }
          this.ngxService.stop();
          this.pageLoading = false;
          this.InitialHeight();
        }
      })

    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (
        res.type === updateInfoType.ReadMspAuthority ||
        res.type === updateInfoType.UpdateMspAuthority ||
        res.type === updateInfoType.DeleteMspAuthority ||
        res.type === updateInfoType.UpdateRegionMember ||
        res.type === updateInfoType.CheckRegionMember
      ) {
        if (!res.isLoading && res.isLoaded && res.isSaved) {

          if (res.type !== updateInfoType.ReadMspAuthority) {
            if (res.type === updateInfoType.CheckRegionMember) {
              if (res.msg.CompanyId !== undefined) {
                this.childDialog.CompanyName = this.regionDic[res.msg.CompanyId] !== undefined ? this.regionDic[res.msg.CompanyId].RegionName : '';
              }
              else if(this.globalSelectedRegionId !== undefined) {
                this.childDialog.CompanyName = this.regionDic[this.globalSelectedRegionId] !== undefined ? this.regionDic[this.globalSelectedRegionId].RegionName : '';
              }
              this.childDialog.errorCompanyMember(res.msg);
            } else {
              let flag = true;
              // 防止重複跳出message
              if (res.type === updateInfoType.UpdateMspAuthority || res.type === updateInfoType.DeleteMspAuthority) {
                flag = false;
                if (this.deleteflag && res.type === updateInfoType.DeleteMspAuthority) {
                  flag = true;
                  this.getMspAuthority();
                } else if (!this.deleteflag && res.type === updateInfoType.UpdateMspAuthority) {
                  flag = true;
                  this.getMspAuthority();
                }
                this.delete_arrary = [];
              } else {
                this.getMspRegion();
              }
              if (flag) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                });
                this.saveButtonDisable = true;
                this.clearMessageService();
              }
            }
          }
          
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          if (res.type === updateInfoType.ReadMspAuthority) {
            // TODO 更完善的 message 處理尚未完成
            // let errMsg = "Read Msp Authority Fail";
            // this.messageService.add({
            //   severity: 'error',
            //   summary: errMsg,
            // });
          } else if (res.type === updateInfoType.UpdateMspAuthority) {
            // TODO 更完善的 message 處理尚未完成
            const errMsg = 'Update Msp Authority Fail';
            this.messageService.add({
              severity: 'error',
              summary: errMsg,
            });
            this.clearMessageService();
            this.getMspAuthority();
          } else if (res.type === updateInfoType.DeleteMspAuthority) {
            // TODO 更完善的 message 處理尚未完成
            const errMsg = 'Delete Msp Authority Fail';
            this.messageService.add({
              severity: 'error',
              summary: errMsg,
            });
            this.clearMessageService();
            this.getMspAuthority();
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Update Fail',
            });
            this.clearMessageService();
            this.getMspAuthority();
          }
        }
        this.resetUpdateInfoState();
      }
    });

  }

  ngOnInit() {
    this.UI();
    // this.getMspAuthority();
    this.initDialogInput();
    // this.applyMspCompanyFilter();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.unsubscribe();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

  getMspRegion() {
    this.ngxService.start();
    this.mspRegionLoaded = false;
    this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
  }

  getMspAuthority() {
    this.ngxService.start();
    this.authorityDictByAcode = {};
    const hashObj = JSON.parse(this.cryptoService.aesDecrypt(this.selectedHashObj));
    const idsTemp = hashObj.id.split(',');
    this.topMspId = -1;
    this.defaultMspId = -1;
    if (idsTemp !== undefined) {
      // 母公司只會有一個Id
      this.topMspId = parseInt(idsTemp[0]);
      if (idsTemp.length > 1) {
        this.defaultMspId = parseInt(idsTemp[1]);
      } else {
        this.defaultMspId = parseInt(idsTemp[0]);
      }
    }
    this.ReadRegionParam = {
      MspMainRegionId: this.topMspId,
      otp: ''
    };
    this.GetMspAuthorityParam = {
      RegionIds: this.defaultMspId !== undefined ? [this.defaultMspId] : [],
      otp: ''
    };
    this.store.dispatch(new fromFeature.GetMspAuthority({ ...this.GetMspAuthorityParam }));
    this.getMspAuthorityFlag = true;
  }

  // 左上方的 company 選單選擇後的動作
  applyMspCompanyFilter() {
    const regionIds = this.defaultMspId == -1
      ? this.mspCompanyOptions.filter((i) => i.value !== -1).map((i) => i.value)
      : [this.defaultMspId];
    this.GetMspAuthorityParam = {
      ...this.GetMspAuthorityParam,
      RegionIds: regionIds,
    };
    this.getMspAuthority();
  }

  onNodeSelect(event: any) {
    this.selectedRegion = event.node;
  }

  onNodeUnselect(event: any) {
    setTimeout(() => {
      this.selectedRegion = event.node;
    });
  }

  selectionChange() {
    if (this.selectedRegion) {
      this.delete_arrary = [];
      this.defaultMspId = this.selectedRegion.data.Id;
      this.selectedRegionId = this.selectedRegion.data.Id;
      this.selectedHashObj = this.selectedRegion.data.HashObj;
      this.selectedRegionName = this.selectedRegion.data.RegionName;
      this.selectedParentRegionId = this.selectedRegion.data.ParentRegionId;
      this.selectedAdmins = this.selectedRegion.data.Admins;
      this.selectedCreateId = this.selectedRegion.data.CreateId;
      this.selectedMainAdmin = this.selectedRegion.data.MainAdmin;
      this.GetMspAuthorityParam = {
        ...this.GetMspAuthorityParam,
        RegionIds: [this.defaultMspId],
      };
      this.getMspAuthority();
    }
  }

  // updateSelectedCheckboxCount(rowData) {
  //   console.log(rowData);
  // }


  goBack(): void {
    this.location.back();
  }

  saveauthorityMgt() {
    this.ngxService.start();
  }

  initDialogInput() {
    this.dialogInput = {
      selectedCompany: [],
    };
  }

  // add icon 按下並打開 add 視窗
  showAddAuthorityDailog(result) {
    this.selectedAddAcode = result.acode;
    this.displayAuthority = true;
    // this.mspCompanyOptions = this.mspCompanyOptions.filter(option => option.value !== 'All');
    this.addMspCompanyOptions = [];
    for (var key in this.regionDic) {
      this.addMspCompanyOptions.push({ label: this.regionDic[key].RegionName, value: key });
    }
    this.dialogInput = {
      selectedCompany: [],
    };
  }

  // add 視窗內, 按下 Save 新增 Authority, 但只在 UI 介面上新增, 並未呼叫 API 真的存入 DB
  saveAuthority() {
    const newAuthorityIds = this.dialogInput.selectedCompany;
    const childrenList = this.authorityDictByAcode[this.selectedAddAcode].children;

    newAuthorityIds.forEach(id => {
      const addRegionId = parseInt(id);
      let isRepeat = false;
      for (var i = 0; i < childrenList.length; i++) {
        if (childrenList[i].data.id === addRegionId) {
          isRepeat = true;
          break;
        }
      }

      if (!isRepeat) {
        const childObj = {
          data: {
            company: this.regionDic[addRegionId] ? this.regionDic[addRegionId].RegionName : '',
            id: addRegionId,
            rowType: 'children',
            view: '0',
            edit: '0',
            ValueType: 'checkbox',
            parentAcode: this.selectedAddAcode,
            isEdited: false,  // 判斷是否為 DB 讀進來後, 或各種情況下被編輯過 (用以判斷 update 時是否把資料放進 API)
            isNew: true  // 判斷是否為 User 新增的資料 (用以判斷 delete 時是否真的需要呼叫 API)
          }
        };
        childrenList.push(childObj);
        // 判斷選到的row把group資料都預設為false
        const rowDataItem = this.authorityMgt_list.find(item => item.data.acode === this.selectedAddAcode);
        const permissionAll = ['view', 'edit'];
        permissionAll.forEach(permission => {
          rowDataItem.data[permission] = '0';
        });
      }
    });

    // 必須要重放資料才會 refresh, 目前無解
    this.applySearch();

    this.displayAuthority = false;
  }

  // delete icon 按下並打開 delete confirm 視窗
  showDeleteConfirmDialog(data) {
    this.selectedDeleteAuthority = {
      RegionId: data.id,
      acode: data.parentAcode
    };
    if (parseInt(data.edit) === -1 && parseInt(data.view) === -1) {
      data.weekly = false;
      data.monthly = false;
      data.mailDisabled = true;
      return;
    } else{
      // 去重複
      if (this.delete_arrary.length > 0 && this.delete_arrary.find(d=>d.RegionId == data.id && d.acode == data.parentAcode) !== undefined) {
        return;
      }
      data.edit = '-1';
      data.view = '-1';
      data.weekly = false;
      data.monthly = false;
      data.mailDisabled = true;
      this.saveButtonDisable = false;
      this.delete_arrary.push(this.selectedDeleteAuthority);
    }

    // this.deleteAuthority();
  }

  // delete confirm 視窗內, 按下 confirm 並呼叫 API 刪除
  // 2025/05/07 基本上此function已經不會再進來了
  deleteAuthority() {
    this.ngxService.start();
    var childrenList = this.authorityDictByAcode[this.selectedDeleteAuthority.acode].children;
    var newChildrenList = [];
    var isDeleteNewData = false;

    // 實作刪除
    for (var i = 0; i < childrenList.length; i++) {
      if (childrenList[i].data.id !== this.selectedDeleteAuthority.RegionId) {
        newChildrenList.push(childrenList[i]);
      } else {
        isDeleteNewData = childrenList[i].data.isNew;  // 判斷只在 UI 上刪除的關鍵
      }
    }
    this.authorityDictByAcode[this.selectedDeleteAuthority.acode].children = newChildrenList;

    if (!isDeleteNewData) {  // 如果是刪掉 New Data, 也就是尚未存入 DB 的 data 時, 不用呼叫 API, 單純是 UI 上在操作而已
      const deleteData: MspDeleteData[] = [];
      deleteData.push({
        acode: this.selectedDeleteAuthority.acode,
        RegionId: this.selectedDeleteAuthority.RegionId
      });
      this.store.dispatch(new fromFeature.DeleteMspAuthority(deleteData));
    }

    const deleteData: MspDeleteData[] = [];
    deleteData.push({
      acode: this.selectedDeleteAuthority.acode,
      RegionId: this.selectedDeleteAuthority.RegionId
    });
    this.store.dispatch(new fromFeature.DeleteMspAuthority(deleteData));

    // 必須要重放資料才會 refresh, 目前無解
    this.applySearch();

    this.displayConfirmDialog = false;
  }

  // 右上角的 Save, 需實際呼叫 API 進行儲存
  saveAllAuthority() {
    this.deleteflag = false;
    if (this.delete_arrary.length > 0) {
      this.deleteflag = true;
      this.store.dispatch(new fromFeature.DeleteMspAuthority([...this.delete_arrary]));
    }
    var isAnyAuthorityEmpty = false;
    const updateData: MspAuthorityForUpdate[] = [];
    for (var key in this.authorityDictByAcode) {
      if (isAnyAuthorityEmpty) {
        break;
      }
      const childrenListTemp = this.authorityDictByAcode[key].children;
      for (var i = 0; i < childrenListTemp.length; i++) {
        if (parseInt(childrenListTemp[i].data.view) !== -1 || parseInt(childrenListTemp[i].data.edit) !== -1) {
          let ViewDeviceNum = parseInt(childrenListTemp[i].data.view) == 1 ? 1 : 0;
          const EditDeviceNum = parseInt(childrenListTemp[i].data.edit) == 1 ? 1 : 0;
          if (parseInt(childrenListTemp[i].data.view) == -1 && parseInt(childrenListTemp[i].data.edit) == 0) {
            ViewDeviceNum = 1;
            childrenListTemp[i].data.view = '1';
          }
          if (parseInt(childrenListTemp[i].data.view) !== -1 && parseInt(childrenListTemp[i].data.edit) !== -1) {
            if ((ViewDeviceNum + EditDeviceNum) === 0) {
              isAnyAuthorityEmpty = true;
              break;
            }
          }
          if (childrenListTemp[i].data.isNew || childrenListTemp[i].data.isEdited) {  // 只有 "新的" 或是 "編輯過" 的資料才要傳給 API
            let newData = {
                acode: parseInt(childrenListTemp[i].data.parentAcode),
                RegionId: childrenListTemp[i].data.id,
                ViewDevice: parseInt(childrenListTemp[i].data.view) === 1,
                EditDevice: parseInt(childrenListTemp[i].data.edit) === 1,
                Note: ''
              } as any;
              
                newData.WeeklyReport = childrenListTemp[i].data.weekly;
                newData.MonthlyReport = childrenListTemp[i].data.monthly;

              updateData.push(newData);
          }
        }
      }
    }

    if (isAnyAuthorityEmpty) {
      // alert('Please check at least one authority is selected in each company.');
      this.ngxService.stop();
    } else {
      if (updateData.length > 0) {
        this.ngxService.start();
        this.store.dispatch(new fromFeature.UpdateMspAuthority(updateData));
      }
    }
  }

  // 權限 checkbox 單一勾選
  selectedOther(event, rowData, type) {
    rowData.isEdited = true;
    this.saveButtonDisable = false;
    if (rowData.mailDisabled) { // 從None切換到Viewer或DeviceManager時把Weekly與Monthly都預設勾選
      rowData.weekly = true;
      rowData.monthly = true;
    }
    rowData.mailDisabled = false;
    rowData.ValueType = 'checkbox';
    if (type == 'edit' && event == '0') {
      event = '1';
    }
    if (this.delete_arrary.length > 0) {
      this.delete_arrary = this.delete_arrary.filter(item => {
        // 若 RegionId 不等於，則保留
        if (item.RegionId !== rowData.id) return true;
        // 若 RegionId 相等，則要判斷 acode 是否不相等才保留
        return item.acode !== rowData.parentAcode;
      });
    }
    const permissions = ['view', 'edit'];
    const permissionsValue = permissions.map(permission => rowData[permission]);
    if (permissionsValue.every(value => value === '1')) {
      rowData.edit = '1';
      if (rowData.rowType === 'Group') {
        const rowDataItem = this.authorityMgt_list.find(item => parseInt(item.data.acode) === parseInt(rowData.acode));
        rowDataItem.children.forEach((child: any) => {
          child.data.view = rowData.view;
          child.data.edit = rowData.edit;
        });
      } else {
        const rowDataItem = this.authorityMgt_list.find(item => parseInt(item.data.acode) === parseInt(rowData.parentAcode));
        const typeListData = rowDataItem.children.map(child => child.data[type] === '1');
        if (typeListData.every(value => value === true)) {
          rowDataItem.data[type] = '1';
        } else {
          rowDataItem.data[type] = '0';
        }
      }
    } else {
      rowData.edit = event;
      const rowDataEvent = event ? '1' : '0';
      if (rowData.rowType === 'Group') {
        const rowDataItem = this.authorityMgt_list.find(item => parseInt(item.data.acode) === parseInt(rowData.acode));
        rowDataItem.children.forEach((child: any) => {
          child.data[type] = rowDataEvent;
          const permissionsValue = permissions.map(permission => child.data[permission]);
          if (permissionsValue.includes('0')) {
            child.data['edit'] = '0';
          } else {
            child.data['edit'] = '1';
          }
          child.data.isEdited = true;
        });
      } else {
        const rowDataItem = this.authorityMgt_list.find(item => parseInt(item.data.acode) === parseInt(rowData.parentAcode));
        const typeListData = rowDataItem.children.map(child => child.data[type] === '1' || (child.data[type] !== -1 && (type == 'edit'? child.data['view'] == -1 : child.data['edit'] == -1)));
        if (typeListData.every(value => value === true)) {
          rowDataItem.data[type] = '1';
        } else {
          rowDataItem.data[type] = '0';
        }
      }
    }
  }

  // --- 處理 Email Report Checkbox 點擊事件 ---
  onMailReportChange(rowData: any) {
    // 標記該筆資料已經被編輯，這樣稍後 saveAllAuthority() 迴圈抓資料時才會把它納入 updateData
    rowData.isEdited = true;
    
    // 將 Save 按鈕啟用 (解除 Disable 狀態)
    this.saveButtonDisable = false;
  }


  applySearch() {
    const searchStringTemp = this.searchString;
    if (!this.mspRegionLoaded) {
      return;
    }
    this.authorityMgt_list = [];
    if (searchStringTemp !== undefined && searchStringTemp != null && searchStringTemp !== '') {
      for (var key in this.authorityDictByAcode) {
        const memberNameTemp = this.authorityDictByAcode[key].data.label;
        if (memberNameTemp.includes(searchStringTemp)) {
          this.authorityMgt_list.push(this.authorityDictByAcode[key]);
        }
      }
    } else {
      for (var key in this.authorityDictByAcode) {
        this.authorityMgt_list.push(this.authorityDictByAcode[key]);
      }
    }

    // setTimeout(() => {
    //   this.ngxService.stop();
    // }, 1000);
  }

  clearMessageService() {
    setTimeout(() => {
      this.messageService.clear();
    }, 2000);
  }

  showAddCompanyMemberDialog(selectedRegionName, selectedRegionId, selectedParentRegionId) {
    if (selectedParentRegionId === -1) {
      this.childDialog.addToHierarchyWarning();
    } else {
      this.globalIsClickMemberbutton = true;
      this.globalSelectedRegionName = selectedRegionName;
      this.globalSelectedRegionId = selectedRegionId;
      this.globalSelectedParentRegionId = selectedParentRegionId;
      this.childDialog.companyMemberList = [];
      this.store.dispatch(new fromMyfeatures.ReadCompanyMember(selectedRegionId));
    }
  }

  controlCompanyMember(result: string) {
    if (result === 'addCompanyMember' || result === 'ImportCompanyMember' || result === 'DeleteCompanyMember') {
      switch (result) {
        case 'addCompanyMember':
          // this.childDialog.CompanyName = '';
          const checkErrorParam = {
            Account: this.childDialog.memberEmailInput,
            RespType: '0',
            SelectCompanyName: this.globalSelectedRegionName
          };
          // 過濾條件0: 是否輸入重複的 email
          let checkEmailIsRepeatResult = false;
          const findEmailRes = this.childDialog.companyMemberList.find(element => element.account === this.childDialog.memberEmailInput);
          if (typeof findEmailRes !== 'undefined' && findEmailRes !== null) {
            checkEmailIsRepeatResult = true;
          }
          if (checkEmailIsRepeatResult) {
            // 重複了 顯示錯誤訊息
            // ShareModel.CheckCompanyMember ErrorMsg number 4: 此 Account 已被加入Member
            checkErrorParam.RespType = '4';
            this.childDialog.errorCompanyMember(checkErrorParam);
            break;
          }

          // 過濾條件1: email的domain與現有 member list 內的 domain 相同 (只比對 list 內第一個)
          let checkSameMemberDomainResult = false;
          try {
            const mList = this.childDialog.companyMemberList;
            if (mList.length === 0) {
              checkSameMemberDomainResult = true;
            } else {
              const firstMemberEmailDomain = mList[0].account.split('@');
              const memberEmailInputDomainSplit = this.childDialog.memberEmailInput.split('@');
              if (firstMemberEmailDomain.length > 1 && memberEmailInputDomainSplit.length > 1) {
                if (firstMemberEmailDomain[1] == memberEmailInputDomainSplit[1]) {
                  checkSameMemberDomainResult = true;
                }
              }
            }
          } catch (error) {
            console.log('exception: controlCompanyMember() => checkSameMemberDomainResult');
          }
          if (!checkSameMemberDomainResult) {
            // 過濾條件1失敗 顯示錯誤訊息
            // ShareModel.CheckCompanyMember ErrorMsg number 5: 此email的domain與 現有 member list 內的 domain 不同
            checkErrorParam.RespType = '5';
            this.childDialog.errorCompanyMember(checkErrorParam);
            break;
          }

          // 過濾條件2: email的domain是否有效, 是否與 local admin 的 domain 相同 (只比對 list 內第一個)
          // let domainEmailCompareResult = false;
          // try {
          //   const regionFind = this.region.find(i => i.Id === this.childDialog.RegionId);
          //   if (typeof regionFind !== 'undefined' && regionFind !== null) {

          //     // 若 Admins 未指定, 直接給過, 因為需要加入任意 member 用來指定 Admin
          //     if (regionFind.Admins === undefined || regionFind.Admins === null || regionFind.Admins.length === 0) {
          //       domainEmailCompareResult = true;
          //     } else {
          //       const firstAdminEmailArray = regionFind.account.split('/');
          //       const firstAdminEmail = firstAdminEmailArray.length > 0 ? firstAdminEmailArray[0] : '';
          //       const firstAdminEmailDomainSplit = firstAdminEmail.split('@');
          //       const memberEmailInputDomainSplit = this.childDialog.memberEmailInput.split('@');
          //       if (firstAdminEmailDomainSplit.length > 1 && memberEmailInputDomainSplit.length > 1) {
          //         if (firstAdminEmailDomainSplit[1] == memberEmailInputDomainSplit[1]) {
          //           domainEmailCompareResult = true;
          //         }
          //       }
          //     }
          //   }
          // } catch (error) {
          //   console.log('exception: controlCompanyMember() => domainEmailCompareResult');
          // }
          // if (!domainEmailCompareResult) {
          //   // 過濾條件2失敗 顯示錯誤訊息
          //   // ShareModel.CheckCompanyMember ErrorMsg number 6: 此email的domain與現有local admin的 domain 不同
          //   checkErrorParam.RespType= "6"
          //   this.childDialog.errorCompanyMember(checkErrorParam);
          //   break;
          // }

          // Acccount過濾條件3失敗 顯示錯誤訊息
          // 不存在此 Account
          // 己存在於其它 MSP 公司
          // 此 Account 不屬於原 Region 下
          // 此 Account 已被加入Member
          const param = {
            otp: '',
            Account: this.childDialog.memberEmailInput,
            RegionId: Array.isArray(this.selectedRegion) ? this.selectedRegion[0].data.Id : this.selectedRegion.data.Id
          };
          this.store.dispatch(new fromFeature.CheckCompanyMember(param));

          break;
        case 'ImportCompanyMember':
          break;
        case 'DeleteCompanyMember':
          break;
      }
    }
  }

  saveCompanyMember(result: string) {
    switch (result) {
      case 'saveCompanyMember':
        this.childDialog.dialogType.CompanyMemberListDialog = false;
        const mailTemp = [];
        if (this.childDialog.companyMemberList.length > 0) {
          this.childDialog.companyMemberList.forEach((item) => {
            mailTemp.push(item.account);
          });
        }
        // 將子公司自動新增的MainMspRegion加回memberlist
        if (this.mainMspAdmin !== undefined && this.mainMspAdmin !== '') {
          mailTemp.push(this.mainMspAdmin);
        } else {
          const mainMspAdmin = 'Region_' + this.childDialog.RegionId + '@cyberpower.com';
          mailTemp.push(mainMspAdmin);
        }
        const param = {
          mail: mailTemp,
          region_id: this.childDialog.RegionId
        };
        this.store.dispatch(new fromMyfeatures.UpdateCompanyMember(param));
        this.ngxService.start();
        break;
    }
  }

  // 將資料轉換成TreeTable格式
  getTreeRegion() {
    const regionMap = new Map<number, any>();
    const regionIds = [];
    const regionWithHash = this.region.map(i => {
      const obj = {
        id: '',
        isDistributor: false
      };
      if (this.ReadRegionParam.MspMainRegionId === i.Id) {
        obj.id = this.ReadRegionParam.MspMainRegionId.toString();
      } else {
        obj.id = this.ReadRegionParam.MspMainRegionId.toString() + ',' + i.Id.toString();
      }
      const hashObj = this.cryptoService.aesEncrypt(obj);
      regionIds.push(i.Id);
      return {
        ...i,
        HashObj: hashObj
      };
    });
    this.treeRegion = regionWithHash.map(i => ({
      data: i,
      children: [],
      expanded: true
    })) as any[];

    this.treeRegion.forEach(node => {
      regionMap.set(node.data.Id, node);
    });

    let transformedRegion: any[] = [];
    this.treeRegion.forEach(node => {
      const parentId = node.data.ParentRegionId;
      const mainRegionId = node.data.MspMainRegionId;
      if (node.data.Id === parentId || node.data.Id === mainRegionId) {
        transformedRegion.push(node);
      } else {
        const parentNode = regionMap.get(parentId);
        if (parentNode) {
          parentNode.children.push(node);
        } else {
          transformedRegion.push(node);
        }
      }
    });

    this.treeRegion = transformedRegion;
    this.selectMainRegionId(this.treeRegion);
  }

  selectMainRegionId(treeRegion) {
    this.defaultMspId = this.ReadRegionParam.MspMainRegionId;
    this.delete_arrary = [];
    if (treeRegion) {
      if (treeRegion[0].data.Id !== this.ReadRegionParam.MspMainRegionId) {
        this.defaultMspId = treeRegion[0].data.Id;
      }
      if (this.selectedRegionId !== undefined) { // 自動選擇至指定公司
        this.defaultMspId = this.selectedRegionId;
      }
      this.selectedRegion = this.getMatchingNodes(treeRegion, this.defaultMspId);
      if (this.selectedRegion !== null && this.selectedRegion.length > 0) {
        this.selectedRegionName = this.selectedRegion[0].data.RegionName;
        this.selectedRegionId = this.selectedRegion[0].data.Id;
        this.selectedParentRegionId = this.selectedRegion[0].data.ParentRegionId;
        this.selectedHashObj = this.selectedRegion[0].data.HashObj;
        this.selectedAdmins = this.selectedRegion[0].data.Admins;
        this.selectedCreateId = this.selectedRegion[0].data.CreateId;
        this.selectedMainAdmin = this.selectedRegion[0].data.MainAdmin;
        this.getMspAuthority();
      }
    }
  }

  getMatchingNodes(tree: any[], targetId: number): any[] {
    let result: any[] = [];
    tree.forEach(node => {
      if (node.data.Id === targetId) {
        result.push(node);
      }
      if (node.children && node.children.length > 0) {
        result = result.concat(this.getMatchingNodes(node.children, targetId));
      }
    });
    return result;
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');
  }

  InitialHeight() {
    const contentListHeight = document.getElementsByClassName('content-list')[0] as HTMLElement;
    if (contentListHeight !== undefined) {
      const mainListContent = self.innerHeight - 240 + 'px';
      contentListHeight.style.height = mainListContent;
    } 
  }
}
